import { useRef, useEffect, useState } from "react";
import icThridBgSrc from "../../assets/images/ic-third-page-bg.png";
import icThridChartSrc from "../../assets/images/ic-third-chart.png";
import icThridPagePhoneSrc from "../../assets/images/ic-thirdpage-phone.png";
import "./thirdpage.css";

const ThirdPage = () => {
    const thirdPageRef = useRef(null);
    const [show, setShow] = useState(false);

    useEffect(() => {
        //for interaction
        const observer = new IntersectionObserver(
            (entries) => {
                entries.map((entry) => {
                    if (entry.isIntersecting && !entry.target.classList.contains("show")) {
                        setShow(true);
                    }
                });
            },
            { threshold: 0.5 }
        );
        observer.observe(thirdPageRef.current);
    }, []);

    return (
        <div className={`${show ? "show" : ""} third-page`} ref={thirdPageRef}>
            <div className="third-page-right">
                <img className="third-page-right-bg" src={icThridBgSrc} />
                <img className="third-page-right-chart" src={icThridChartSrc} />
                <img className="third-page-right-phone" src={icThridPagePhoneSrc} />
            </div>

            <div className="third-page-left">
                <div className="third-title title">
                    {"Earn up to "}
                    <span>3x profits</span>
                </div>
                <div className="third-subtitle subtitle">
                    {"G1 CASH lets you generate profits up to\n 3 times the original amount, making your\n investments work even harder for you."}
                </div>
                <div className="third-subtitle-second subtitle">
                    <span>G1CASH</span>
                    {" today!"}
                </div>
            </div>
        </div>
    );
};

export default ThirdPage;
